import { SET_MENU_OPEN, SET_MENU_CLOSE } from './actionTypes';

export function setMenuOpen() {
  return {
    type: SET_MENU_OPEN
  }
}

export function setMenuClose() {
  return {
    type: SET_MENU_CLOSE
  }
}
